"use client";
import { useTranslation } from "react-i18next";

export const Header = (): JSX.Element => {
  const { t } = useTranslation();
  document.title = t("common.applicationName");
  return <header className="rsi-header" data-title={t("common.applicationName")} data-help-url="/app/help"></header>;
};
